var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#437EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1666 15.0003V19.5837C24.1666 22.3337 22.3333 24.167 19.5833 24.167H10.4166C7.66665 24.167 5.83331 22.3337 5.83331 19.5837V15.0003C5.83331 12.507 7.33665 10.7653 9.67415 10.472C9.91248 10.4353 10.16 10.417 10.4166 10.417H19.5833C19.8216 10.417 20.0508 10.4261 20.2708 10.4628C22.6358 10.7378 24.1666 12.4887 24.1666 15.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2721 10.4622C20.0521 10.4255 19.823 10.4164 19.5846 10.4164H10.418C10.1613 10.4164 9.91381 10.4347 9.67548 10.4713C9.80381 10.2147 9.98714 9.97635 10.2071 9.75635L13.1863 6.76801C14.4421 5.52134 16.4771 5.52134 17.733 6.76801L19.3371 8.39053C19.9238 8.96803 20.2355 9.70134 20.2721 10.4622Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1666 15.458H21.4166C20.4083 15.458 19.5833 16.283 19.5833 17.2913C19.5833 18.2997 20.4083 19.1247 21.4166 19.1247H24.1666",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferBag);
export default __webpack_public_path__ + "static/media/TransferBag.69214fd0aeca07c51d34d79d5c709952.svg";
export { ForwardRef as ReactComponent };